<script>
    import { createEventDispatcher } from 'svelte';

    export let link;

    const dispatch = createEventDispatcher();

    let editing = false;

    let newText = '';
    let newRef = '';

    function toggleEditing() {
        if (!editing || !newText || !newRef) {
            editing = !editing;
            newText = '';
            newRef = '';
            return;
        }
        dispatch('updateLink', {
            oldText: link.text,
            oldRef: link.ref,
            text: newText,
            ref: newRef
        });
        editing = !editing;
        newText = '';
        newRef = '';
    }

    function onDelete() {
        dispatch('deleteLink', {
            text: link.text,
            ref: link.ref
        });
        editing = false;
        newText = '';
        newRef = '';
    }
</script>

<div class="row">
    <div class="link">
        <div class={(editing) ? "text text-editing" : "text"}>
            {#if !editing}
                <p>{link.text}</p>
            {:else}
                <input bind:value={newText} type="text" placeholder={link.text}>
            {/if}
        </div>
        <div class={(editing) ? "ref ref-editing" : "ref"}>
            {#if !editing}
                <a href='{link.ref}' target='_blank'>{link.ref}</a>
            {:else}
                <input bind:value={newRef} type="text" placeholder={link.ref}>
            {/if}
        </div>
    </div>
    <i on:click={toggleEditing} class={(editing) ? "far fa-check" : "far fa-pencil"}></i>
    <i on:click={onDelete} class="far fa-trash-alt"></i>
</div>

<style>
    .row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        margin: 20px 0px;
    }

    .link {
        text-align: left;
        background-color: var(--light-black);
        border-radius: 10px;
        color: white;
        margin-right: 10px;
        padding: 10px;
        box-shadow: var(--box-shadow);
    }

    .text {
        font-size: 22px;
        margin-bottom: 5px;
    }

    .text-editing {
        padding: 10px 10px 0px 10px;
    }

    .ref {
        background-color: var(--primary);
        border-radius: 5px;
        padding: 10px 10px 7px 10px;
        box-shadow: var(--box-shadow);
    }

    .ref-editing {
        background-color: transparent;
    }

    .ref a {
        color: inherit;
    }

    i {
        cursor: pointer;
        font-size: 28px;
        vertical-align: middle;
        margin-left: 8px;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    i:hover {
        color: var(--primary);
    }
</style>
